import { useState, useCallback, useEffect } from "react";

const
    persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

export const fixNumbers = function (str) {
    if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
    }
    return str;
};

/**
 * a react hook for creating toggling values, which automatically become false after a short timeout
 * @param {boolean} initialValue 
 * @returns {[boolean, ()=>void]}
 */
export function useAutoToggle(initialValue = false) {
    const [toggleValue, setToggleValue] = useState(initialValue)

    const toggleTrue = useCallback(() => setToggleValue(true), [])
    useEffect(() => {
        if (toggleValue) {
            setTimeout(() => setToggleValue(false), 50)
        }
    }, [toggleValue])
    return [toggleValue, toggleTrue]
}